import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FMDPStorage } from "../shared/helper";
import {
  ClientSection,
  UsersContainer,
  DMansContainer,
  DModelsContainer,
  DeviceModel,
  VTypesContainer,
  VClassesContainer,
  VMansContainer,
  VManufacturer,
  VManModelsContainer,
  VManModelVariantsContainer,
  VModelsContainer,
  VariablesContainer,
  VariableMappingsContainer,
  BackendsContainer,
  GeocodersContainer,
  ObdCodesContainer,
  BatchCommandContainer,
  DevicesContainer,
  VehiclesContainer,
  AdminDashboard,
  UserProfile as AdminUserProfile,
  AuditTrail as AdminAuditTrail,
  GeolocationContainer as AdminGeolocationContainer,
  MSPContainer as AdminMSPContainer,
  LocalizationContainer as AdminLocalizationContainer,
  CommandsContainer as AdminCommandsContainer,
  DisplayConfigurationsContainer as AdminDisplayConfigurationsContainer,
} from "./Admin";

import { LoginForm, RoleSelection, ResetPassword, ResetPasswordOtp } from "./Authentication";

import {
  DeviceContainer as MPDeviceContainer,
  RolesContainer,
  DataAccessContainer,
  UsersContainer as MPUsersContainer,
  VClassesContainer as MPVClassesContainer,
  VTypesContainer as MPVTypesContainer,
  VMansContainer as MpVManContainer,
  VManModelsContainer as MPVManModelsContainer,
  VModelsContainer as MPVModelsContainer,
  VManModelVariantContainer as MPVManModelVariantContainer,
  VehiclesContainer as MPVehiclesContainer,
  MPDashboard,
  UserProfile as MPUserProfile,
  AuditTrail as MPAuditTrail,
  BackendsContainer as MPBackendsContainer,
  DModelsContainer as MPDModelsContainer,
  DeviceGroupsContainer as MPDeviceGroupsContainer,
  VehicleGroupsContainer as MPVehicleGroupsContainer,
  UserGroupsContainer as MPUserGroupsContainer,
  CustomizationContainer,
  ApiListContainer,
  GeofenceContainer as MPGeofenceContainer,
  ReportConfigurationsContainer as MPReportConfigurationsContainer,
  EventConfigurationsContainer as MPEventConfigurationsContainer,
  EventConfigurationsPlanContainer as MPEventConfigurationsPlanContainer,
  EventTypesContainer as MPEventTypesContainer,
  MPPluginContainer,
  TripsContainer as MPTripsContainer,
  SimCardsContainer as MPSimCardsContainer,
  AddCustomPluginContainer,
  MPRenderDynamicContainer,
  MPRenderDynamicTab,
  MPRenderFirstPluginContainer,
  ClientsContainer as MPClientsContainer,
  ReportsContainer as MPReportsContainer,
  CustomFieldsSection as MPCustomFieldsSection,
} from "./ManagementPortal";

import {
  VehicleAlternateContainer as TVehicleAlternateContainer,
  VehicleContainer as TVehicleContainer,
  DeviceContainer as TDeviceContainer,
  DeviceAlternateContainer as TDeviceAlternateContainer,
  VehicleDetails as TVehicleDetails,
  RouteDetails as TRouteDetails,
  TripsAlternateContainer as TTripsAlternateContainer,
  TripsContainer as TTripsContainer,
  ReportsContainer as TReportsContainer,
  DashBoardContainer as TDashBoardContainer,
  EventsAlternateContainer as TEventAlternateContainer,
  EventsContainer as TEventContainer,
  ActivitiesAlternateContainer as TActivitiesAlternateContainer,
  ActivitiesContainer as TActivitiesContainer,
  TPluginContainer,
} from "./Tracking";

import { PrintPreviewPage } from "./Tracking/Reports/PrintPreviewPage";
import { FleetPerformancePreviewPage } from "./Tracking/Reports/FleetPerformance/FleetPerformancePreviewPage";

import { PluginsManagerContainer } from "./ManagementPortal";
import { JsonRenderer } from "../assets/clients/JsonRenderer";

import { Documentation } from "./Documentation";
import { LoggedOut } from "./LoggedOut";

import { AdminLayout } from "./Admin/layout";
import { MPLayout } from "./ManagementPortal/layout";
import { TrackingLayout } from "./Tracking/layout";
import { DriverBehaviorLayout } from "./DriverBehavior/layout";
import { TAddCustomPluginContainer } from "./Tracking/CustomPluginContainer/CustomPluginContainerManager";
import { ContainersManagerContainer } from "./ManagementPortal/Customization/ContainersManager";
import { EmailNotificationConfig } from "./ManagementPortal/Customization/EmailNotificationConfig";
import { TrackDevice } from "./Tracking/TrackDevice";
import { useGetDisplayConfigQuery } from "./ManagementPortal/services";

import { DriverBehaviorDashboard, VendorContainer, ReportsContainer } from "./DriverBehavior";
import { AreasContainer } from "./DriverBehavior/Areas";

export const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/superadmin/" element={<AdminLayout />}>
        <Route path="devices">
          <Route path="manufacturers" element={<DMansContainer />} />
          <Route path="models" element={<DModelsContainer />} />
          <Route path="models/:deviceModelId" element={<DeviceModel />} />
          <Route path="list" element={<DevicesContainer />} />
          <Route index element={<Navigate to="list" />} />
        </Route>

        <Route path="vehicles">
          <Route path="types" element={<VTypesContainer />} />
          <Route path="classes" element={<VClassesContainer />} />
          <Route path="manufacturers" element={<VMansContainer />} />
          <Route path="manufacturers/:vManId" element={<VManufacturer />} />
          <Route path="manufacturer_models" element={<VManModelsContainer />} />
          <Route path="variants" element={<VManModelVariantsContainer />} />
          <Route path="specifications" element={<VModelsContainer />} />
          <Route path="list" element={<VehiclesContainer />} />
          <Route index element={<Navigate to="list" />} />
        </Route>
        <Route path="others">
          <Route path="variables" element={<VariablesContainer />} />
          <Route path="variable_mappings" element={<VariableMappingsContainer />} />
          <Route path="backends" element={<BackendsContainer />} />
          <Route path="geocoders" element={<GeocodersContainer />} />
          <Route path="geolocation_plan" element={<AdminGeolocationContainer />} />
          <Route path="obd_codes" element={<ObdCodesContainer />} />
          <Route path="batch_command" element={<BatchCommandContainer />} />
          <Route index element={<Navigate to="variables" />} />
          <Route path="msp" element={<AdminMSPContainer />} />
          <Route path="localization" element={<AdminLocalizationContainer />} />
          <Route path="commands" element={<AdminCommandsContainer />} />
          <Route path="display" element={<AdminDisplayConfigurationsContainer />} />
        </Route>
        <Route path="clients" element={<ClientSection />} />
        <Route path="users" element={<UsersContainer />} />
        <Route path="user-profile" element={<AdminUserProfile />} />
        <Route path="audit-trail" element={<AdminAuditTrail />} />
        <Route index element={<AdminDashboard />} />
      </Route>

      <Route path="*" element={<Navigate to="/superadmin/" />} />
    </Routes>
  );
};

//Routes for management portal
export const MPRoutes = () => {
  const isReseller = FMDPStorage?.get("reseller");

  return (
    <Routes>
      <Route path="/management_portal" element={<MPLayout />}>
        <Route path="" element={<Navigate to="dashboard" />} />
        <Route path="dashboard" element={<MPDashboard />} />
        <Route path="devices">
          <Route path="list" element={<MPDeviceContainer />} />
          <Route path="models" element={<MPDModelsContainer />} />
          <Route path=":groupName/plugin/:pluginPath" element={<MPRenderDynamicTab />} />
          <Route index element={<Navigate to="list" />} />
        </Route>
        <Route path="others">
          <Route path="backends" element={<BackendsContainer />} />
          <Route path="geofence" element={<MPGeofenceContainer />} />
          <Route index element={<Navigate to="backends" />} />
        </Route>
        <Route path="configurations">
          <Route path="backends" element={<MPBackendsContainer />} />
          <Route path="geofence" element={<MPGeofenceContainer />} />
          <Route path="report" element={<MPReportConfigurationsContainer />} />
          <Route path="events" element={<MPEventConfigurationsContainer />} />
          <Route path="event_types" element={<MPEventTypesContainer />} />
          <Route path="event_plans" element={<MPEventConfigurationsPlanContainer />} />
          <Route path="trips" element={<MPTripsContainer />} />
          <Route path="sim_cards" element={<MPSimCardsContainer />} />
          <Route path="custom_fields" element={<MPCustomFieldsSection />} />
          <Route path=":groupName/plugin/:pluginPath" element={<MPRenderDynamicTab />} />
          <Route index element={<Navigate to="backends" />} />
        </Route>
        <Route path="vehicles">
          <Route path="classes" element={<MPVClassesContainer />} />
          <Route path="types" element={<MPVTypesContainer />} />
          <Route path="manufacturers" element={<MpVManContainer />} />
          <Route path="manufacturers_models" element={<MPVManModelsContainer />} />
          <Route path="specifications" element={<MPVModelsContainer />} />
          <Route path="variants" element={<MPVManModelVariantContainer />} />
          <Route path=":groupName/plugin/:pluginPath" element={<MPRenderDynamicTab />} />
          <Route path="list" element={<MPVehiclesContainer />} />
          <Route index element={<Navigate to="list" />} />
        </Route>
        <Route path="groups">
          <Route path="device" element={<MPDeviceGroupsContainer />} />
          <Route path="vehicle" element={<MPVehicleGroupsContainer />} />
          <Route path="user" element={<MPUserGroupsContainer />} />
          <Route path=":groupName/plugin/:pluginPath" element={<MPRenderDynamicTab />} />
          <Route index element={<Navigate to="vehicle" />} />
        </Route>
        <Route path="users_roles">
          <Route path="users" element={<MPUsersContainer />} />
          <Route path="drivers" element={<Navigate to="../users" replace />} />
          <Route path="roles" element={<RolesContainer />} />
          <Route path="data_access" element={<DataAccessContainer />} />
          <Route path=":groupName/plugin/:pluginPath" element={<MPRenderDynamicTab />} />
          <Route index element={<Navigate to="users" />} />
        </Route>
        <Route path="plugin/:path" element={<MPPluginContainer />} />

        <Route path="audit-trail" element={<MPAuditTrail />} />
        <Route path="container/:path">
          <Route path="header/plugin/:pluginPath" element={<MPRenderDynamicContainer />} />
          <Route path="primaryPlugin" element={<MPRenderFirstPluginContainer />} />
          <Route index element={<Navigate to="primaryPlugin" />} />
        </Route>
        <Route path="add-container" element={<AddCustomPluginContainer />} />
        <Route path="audit-trail" element={<MPAuditTrail />} />
        {isReseller && <Route path="clients" element={<MPClientsContainer />} />}
        {isReseller && <Route path="reports" element={<MPReportsContainer />} />}
        <Route path="user-profile" element={<MPUserProfile />} />
        <Route path="sim_cards" element={<MPSimCardsContainer />} />

        <Route path="client_config">
          <Route path="plugins_manager" element={<PluginsManagerContainer />} />
          <Route path="portal_customization" element={<CustomizationContainer />} />
          <Route path="api_keys" element={<ApiListContainer />} />
          <Route index element={<Navigate to="portal_customization" />} />
          <Route path="containers" element={<ContainersManagerContainer />} />
          <Route path="email_notification_configuration" element={<EmailNotificationConfig />} />
        </Route>
        <Route path="*" element={<Navigate to="/management_portal/dashboard" />} />
      </Route>

      <Route path="*" element={<Navigate to="/management_portal/dashboard" />} />
    </Routes>
  );
};

export const TrackingRoutes = () => {
  const currentUserDetails = FMDPStorage?.get("current-user");
  const currentUser = currentUserDetails?.client_apps;
  const currentClientId = FMDPStorage?.get("selected-client-id");
  const [configJson, setConfigJson] = useState({});
  const [isAlternativeUI, setIsAlternativeUI] = useState(false);
  const [displayConfigId, setDisplayConfigId] = useState(null);
  const [defaultTrackingPage, setDefaultTrackingPage] = useState("vehicles");

  // To get the custom config for handling the alternative UI
  useEffect(() => {
    if (currentClientId && currentUser) {
      currentUser?.map((clientApp) => {
        if (clientApp?.client?.id === currentClientId) {
          setDisplayConfigId(clientApp?.client?.display_configuration_id);
          setConfigJson(clientApp?.client?.config_json);
        }
      });
    }
  }, [currentClientId]);

  const { data: selectedDisplayConfig, refetch } = useGetDisplayConfigQuery(
    { id: displayConfigId },
    {
      skip: !displayConfigId || !currentClientId,
      refetchOnMountOrArgChange: true,
    }
  );

  // Force refetch when displayConfigId changes
  useEffect(() => {
    if (displayConfigId && currentClientId) {
      refetch();
    }
  }, [displayConfigId, currentClientId, refetch]);

  useEffect(() => {
    if (
      selectedDisplayConfig?.default_tracking_portal_landing &&
      currentClientId &&
      displayConfigId
    ) {
      FMDPStorage.set(
        "default-tracking-page",
        selectedDisplayConfig?.default_tracking_portal_landing
      );
      FMDPStorage.set("variable-ids", JSON.stringify(selectedDisplayConfig?.variables));
      setDefaultTrackingPage(selectedDisplayConfig?.default_tracking_portal_landing);
    }
  }, [selectedDisplayConfig, currentClientId, displayConfigId]);

  // Handling alternative UI from the current user or custom json otherwise show the default UI
  useEffect(() => {
    if (configJson) {
      try {
        if (currentUserDetails?.layout === "Default") {
          setIsAlternativeUI(false);
          FMDPStorage.set("alternative-layout", false);
        } else if (currentUserDetails?.layout === "Alternative") {
          setIsAlternativeUI(true);
          FMDPStorage.set("alternative-layout", true);
        } else if (JSON?.parse(configJson)?.tracking?.web?.tracking_layout === "alternative") {
          setIsAlternativeUI(true);
          FMDPStorage.set("alternative-layout", true);
        } else {
          setIsAlternativeUI(false);
          FMDPStorage.set("alternative-layout", false);
        }
      } catch {
        setIsAlternativeUI(false);
        FMDPStorage.set("alternative-layout", false);
      }
    }
  }, [configJson, currentUserDetails]);

  // Only render routes when defaultTrackingPage is available
  if (!defaultTrackingPage) {
    return null;
  }

  return (
    <Routes key={defaultTrackingPage}>
      <Route path="/tracking" element={<TrackingLayout setDefaultTrackingPage={setDefaultTrackingPage} />}>
        <Route path="" element={<Navigate to={`/tracking/${defaultTrackingPage}`} />} />
        <Route path="dashboard" element={<TDashBoardContainer />}></Route>
        {isAlternativeUI ? (
          <>
            <Route path="vehicles" element={<TVehicleAlternateContainer />} />
            <Route path="devices" element={<TDeviceAlternateContainer />} />
            <Route path="trips" element={<TTripsAlternateContainer />}></Route>
            <Route path="activities" element={<TActivitiesAlternateContainer />}></Route>
            <Route path="events" element={<TEventAlternateContainer />}></Route>
          </>
        ) : (
          <>
            <Route path="vehicles" element={<TVehicleContainer />} />
            <Route path="devices" element={<TDeviceContainer />} />
            <Route path="trips" element={<TTripsContainer />}></Route>
            <Route path="activities" element={<TActivitiesContainer />}></Route>
            <Route path="events" element={<TEventContainer />}></Route>
          </>
        )}

        <Route path="device-details/:imei" element={<TVehicleDetails />} />
        <Route path="track/:imei" element={<TRouteDetails />}></Route>
        <Route path="reports" element={<TReportsContainer />}></Route>
        {/* Print preview route moved outside layout above */}

        <Route path="plugin/:path" element={<TPluginContainer />} />
        <Route path="container/:path">
          <Route path="header/plugin/:pluginPath" element={<MPRenderDynamicContainer />} />
          <Route path="primaryPlugin" element={<MPRenderFirstPluginContainer />} />
          <Route index element={<Navigate to="primaryPlugin" />} />
        </Route>
        <Route path="add-container" element={<TAddCustomPluginContainer />} />
        <Route path="reports/print-preview" element={<PrintPreviewPage />}></Route>
        <Route path="reports/fleet-performance-preview" element={<FleetPerformancePreviewPage />}></Route>
        <Route path="*" element={<Navigate to={`/tracking/${defaultTrackingPage}`} />} />
      </Route>
      <Route path="*" element={<Navigate to={`/tracking/${defaultTrackingPage}`} />} />
    </Routes>
  );
};

export const AuthenticationRoutes = () => {
  return (
    <Routes>
      <Route exact path="/login" element={<LoginForm />} />
      <Route exact path="/app-selection" element={<RoleSelection />} />
      <Route exact path="/password-reset" element={<ResetPassword />} />
      <Route exact path="/users/reset_password/:id" element={<ResetPasswordOtp />} />
      <Route path="tracking" element={<TrackDevice />}></Route>
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

// Add the routes which doesn't needs the authentication like docs, product show page, logged out page.
// Also the all of these paths must need to be added inside App.js in  UN_AUTHETICATED_ROUTES list

export const DriverBehaviorRoutes = () => {
  return (
    <Routes>
      <Route path="/driver-behavior" element={<DriverBehaviorLayout />}>
        <Route path="" element={<Navigate to="/driver-behavior/dashboard" replace />} />
        <Route path="dashboard" element={<DriverBehaviorDashboard />} />
        <Route path="vendor" element={<VendorContainer />} />
        <Route path="areas" element={<AreasContainer />} />
        <Route path="reports" element={<ReportsContainer />} />
        <Route path="*" element={<Navigate to="/driver-behavior/dashboard" />} />
      </Route>
      <Route path="*" element={<Navigate to="/driver-behavior/dashboard" />} />
    </Routes>
  );
};

export const UnAuthenticatedRoutes = () => {
  return (
    <Routes>
      <Route exact path="/documentation" element={<Documentation />} />
      <Route path="/clients/:client_id/config.json" element={<JsonRenderer />} />
      <Route exact path="/logged_out" element={<LoggedOut />} />
    </Routes>
  );
};
